module.exports = __webpack_public_path__ + "img/MF_Verify_wm1line_color_rgb.e1fb7419.png";